import $ from 'jquery'

function init(){

    let $layouts = $('[data-site-layouts]')
    let $searchInput = $('.header-search--input input')

    $('[data-trigger-icon]').on('click', function () {
        let $dVal = $(this).attr('data-trigger-icon')
        $layouts.toggleClass($dVal)
        if($dVal === 'active-search' && $layouts.hasClass('active-search') ) {
            $searchInput.focus()
        }
    })
}

export default init
